module.exports = __webpack_public_path__ + "img/schoolNews-title.0a767901.png";